import * as z from 'zod'
import { DriverRegistrationRequest, ThumbType } from '~/shared/api'

export const formSchema = DriverRegistrationRequest.schema.pick({
  drivingLicenseIssuingCountry: true,
  drivingLicensePhotos: true,
})

export type SchemaType = z.infer<typeof formSchema>

export type FormValues = Omit<SchemaType, 'drivingLicensePhotos'> & {
  drivingLicensePhotos: ThumbType[] | UniqueId[]
}
